import {datadogRum} from "@datadog/browser-rum";

import React from "react";
import * as ReactDOM from "react-dom";

import config from "../config";
import Root from "./Root";

import "./styles/styles.scss";

datadogRum.init({
  ...config.datadog,
  version: process.env.APP_VERSION,
});
datadogRum.startSessionReplayRecording();

const domContainer = document.querySelector("#app");
ReactDOM.render(<Root />, domContainer);
